import {Component, OnDestroy, OnInit, signal, ViewChild, WritableSignal} from '@angular/core';
import {Subscription} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {UtilsService} from '../../../core/utils/utils.service';
import {StocksSupplier} from '../stocks-resolver.service';
import {FormControl, FormGroup} from '@angular/forms';
import {catchError, debounceTime, distinctUntilChanged, filter, map, switchMap, tap} from 'rxjs/operators';
import {TreeNode} from 'primeng/api';
import {DATEPICKER_FR, STOCKS_FEATURES} from '../../../core/constants';
import {SiteInventaireDisponible, StocksService} from '../../../core/services/gestion-stock/stocks.service';
import {HistoriqueInventaireConflitDto} from "../../../core/dtos/historique-inventaire-conflit-dto";
import {
  ProduitDeclinaisonService,
  SearchStockSupplier
} from '../../../core/services/entities/produit-declinaison.service';
import {DxTreeViewComponent} from "devextreme-angular";
import {SiteDTO} from "../../../core/dtos/site-dto";
import {Auth2Service} from "../../../core/services/security/auth2.service";
import {ButtonThemeEnum} from "../../../shared/ui/button/button-theme-enum";
import {DateLevelEnum} from "../../../shared/date/picker/date-level-enum";
import {SelectOption} from "../../../shared/ui/select-option";
import {confirm} from "devextreme/ui/dialog";

@Component({
  selector: 'yo-search-panel',
  templateUrl: './search-panel.component.html',
  styleUrls: [
    '../../gestion-stocks-root.component.scss',
    './search-panel.component.scss'
  ],
  standalone: false
})
export class SearchPanelComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;
  public readonly DateLevelEnum = DateLevelEnum;

  subRoute: Subscription;
  subFeature: Subscription;
  subPaginationSearchStock: Subscription;
  subFormSearch: Subscription;
  subLotsDeleted: Subscription;

  formSearch: FormGroup;
  feature: string;

  page = 0;
  size = 50;

  selectedNodes: TreeNode[] = [];
  searchStockSupplier: SearchStockSupplier;

  seuils: SelectOption[] = [];

  localeFr = DATEPICKER_FR;

  sites: SiteDTO[] = [];

  zonesStockages: any[] = [];
  @ViewChild("treeViewZonesStockages", {static: false}) treeViewZonesStockages: DxTreeViewComponent;
  idsUdpZonesStockagesSelected: number[] = [];
  idsZonesStockagesSelected: number[] = [];

  idsSitesSelected: number[] = [];

  dateEntreeSelected: Date;
  datePeremptionSelected: Date;

  isHistoryMode: boolean = false;
  isSavingHistorique: boolean = false;
  isHistoryVisible: boolean = false;
  historySiteSelected: SiteDTO;
  availableHistoriqueDates: Date[] = [];
  historySites: SiteDTO[] = [];
  sitesDisponiblesInventaire: SiteInventaireDisponible[] = [];
  histoDate: Date;
  inventaireDate: Date;
  inventaireDatesDisponibles: Date[] = [];

  typesAlimentaire = [
    {id: 'true', libelle: 'Alimentaire'},
    {id: 'false', libelle: 'Non Alimentaire'}
  ];

  typeAlimentaireSelected: Boolean = null;

  conflitList: WritableSignal<HistoriqueInventaireConflitDto[]> = signal<HistoriqueInventaireConflitDto[]>([]);
  displayConflitInventairePopup: any = signal<Boolean>(false);
  isCheckingConflits: boolean = false;

  constructor(
    public utils: UtilsService,
    private route: ActivatedRoute,
    private stocksSvc: StocksService,
    private auth2Svc: Auth2Service,
    private produitDeclinaisonSvc: ProduitDeclinaisonService,
    private stockSvc: StocksService) {
    this.seuils = [
      {value: "4", label: "Articles jamais commandés"},
      {value: "0", label: "Articles commandés sans stocks"},
      {value: "1", label: "Articles commandés avec stocks"},
      {value: "3", label: "Tous"}
    ];
  }

  ngOnInit() {
    this.initForm();
    // fonctionnalité du stock (inventaire, historique...)
    this.subscriptionFeature();
    // la pagination a changé (grille inventaire, matiere premiere ...)
    this.subscriptionPaginationSearchStock();
    this.onChangeSearchUpdateFilter();
    this.initSites();
    this.loadSitesDisponiblesInventaire();
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subRoute);
    this.utils.unsubscribe(this.subFeature);
    this.utils.unsubscribe(this.subPaginationSearchStock);
    this.utils.unsubscribe(this.subLotsDeleted);
  }

  initSites = (): void => {
    this.sites = this.auth2Svc.utilisateur.siteListLocaux;
    if (this.sites && this.sites.length) {
      this.sites = this.sites.sort((s1, s2) => s1.libelle.localeCompare(s2.libelle));
      this.idsSitesSelected.push(this.sites[0].id);
      this.updateUdpZds();
    }
  }

  onChangeSite = ($event): void => {
    if ($event.addedItems?.length) {
      $event.addedItems.forEach(item => {
        if (!this.idsSitesSelected.filter(idSite => idSite === item.id).length) {
          this.idsSitesSelected.push(item.id);
        }
      });
    }
    if ($event.removedItems?.length) {
      $event.removedItems.forEach(item => {
        if (this.idsSitesSelected.filter(idSite => idSite === item.id).length) {
          this.idsSitesSelected = this.idsSitesSelected.filter(idSite => idSite !== item.id);
        }
      });
    }
    if (this.idsSitesSelected && this.idsSitesSelected.length) {
      this.updateUdpZds();
    }
  }

  initForm = () => {
    this.formSearch = new FormGroup({
      denree: new FormControl(''),
      codeDenree: new FormControl(''),
      denominationArticle: new FormControl(''),
      referenceInterneArticle: new FormControl(''),
      datePeremption: new FormControl(undefined),
      dateEntree: new FormControl(undefined),
      thresholdStocks: new FormControl('1'),
      typeAlimentaire: new FormControl(null),
    });
  };

  onTypeAlimentaireChanged = ($event: Boolean): void => {
    this.typeAlimentaireSelected = $event;
    this.formSearch.patchValue({typeAlimentaire: $event});
  };

  subscriptionFeature = () => {
    this.subFeature = this.stocksSvc.feature$
      .pipe(
        map(value => {
          this.feature = value.feature;
          const page = value.page ? value.page - 1 : 1;
          const size = value.size ? value.size : 50;
          this.searchStockSupplier = new SearchStockSupplier(this.formSearch.value, this.selectedNodes, this.feature, page, size);
        }),
        filter(() => !this.isHistoryMode || this.isHistoryFormComplete()),
        tap(() => {
          this.toogleLoading(false);
        }),
        switchMap(value => {
          return this.searchStockSupplier?.feature === STOCKS_FEATURES.INVENTAIRE ?
            this.produitDeclinaisonSvc.searchInventaires(this.searchStockSupplier, this.idsSitesSelected, this.idsZonesStockagesSelected, this.idsUdpZonesStockagesSelected, this.isHistoryMode ? this.inventaireDate : undefined)
            : this.produitDeclinaisonSvc.searchInStock(this.searchStockSupplier, this.idsSitesSelected, this.idsZonesStockagesSelected, this.idsUdpZonesStockagesSelected)
        }),
        map(response => this.produitDeclinaisonSvc.announceResultSearchStocks(response, this.searchStockSupplier)),
        catchError(err => {
          this.toogleLoading(false);
          return this.utils.handleError(err)
        }))
      .subscribe();
  };

  toogleLoading(isEnabled: boolean): void {
    if (this.searchStockSupplier?.feature === STOCKS_FEATURES.INVENTAIRE)
      this.stocksSvc.announceInventaireLoading(isEnabled);
  }

  subscriptionPaginationSearchStock = () => {
    this.subPaginationSearchStock = this.produitDeclinaisonSvc.paginationSearchStock$.pipe(
      map(response => this.searchStockSupplier = new SearchStockSupplier(this.formSearch.value, this.selectedNodes, this.feature, response.page, response.size)),
      filter(() => !this.isHistoryMode || this.isHistoryFormComplete()),
      tap(() => {
        if (this.searchStockSupplier?.feature === STOCKS_FEATURES.INVENTAIRE) this.stocksSvc.announceInventaireLoading(true);
      }),
      switchMap(response => this.searchStockSupplier?.feature === STOCKS_FEATURES.INVENTAIRE ? this.produitDeclinaisonSvc.searchInventaires(this.searchStockSupplier, this.idsSitesSelected, this.idsZonesStockagesSelected, this.idsUdpZonesStockagesSelected, this.isHistoryMode ? this.inventaireDate : undefined) : this.produitDeclinaisonSvc.searchInStock(this.searchStockSupplier, this.idsSitesSelected, this.idsZonesStockagesSelected, this.idsUdpZonesStockagesSelected)),
      map(response => this.produitDeclinaisonSvc.announceResultSearchStocks(response, this.searchStockSupplier)),
      catchError(err => this.utils.handleError(err))
    ).subscribe();

    this.subRoute = this.route.data
      .subscribe((data: { stocksSupplier: StocksSupplier }) => {
        this.zonesStockages = data.stocksSupplier.tree;
        if (this.zonesStockages && this.zonesStockages.length) {
          this.zonesStockages.forEach(udp => {
            udp.zonesStockage.forEach(zds => zds["icon"] = "fas fa-home");
            udp.id = `udp-${udp.id}`;
            udp["icon"] = "fa-industry fas";
            udp["items"] = udp.zonesStockage.map(zds => ({...zds, id: `${udp.id}-${zds.id}-${zds.idUdpZds}-zds`}));
            udp["expanded"] = true;
          });
        }
      });

    // lorqu'il y a eu une suppression de lot périmé, on réinit le filtre date "Périmé le" et on relance la recherhce
    this.subLotsDeleted = this.stockSvc.lotsDeleted$.pipe(
      tap(() => this.formSearch.controls['datePeremption'].setValue(undefined))
    ).subscribe();
  };

  onChangeSearchUpdateFilter = (): void => {
    this.formSearch.valueChanges.subscribe(e => this.formSearch.setValue(e, {emitEvent: false})); // Migrer à 10.0.4
    this.subFormSearch = this.formSearch.valueChanges.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      map(values => this.searchStockSupplier = new SearchStockSupplier(values, this.selectedNodes, this.feature, 0, 50)),
      filter(() => !this.isHistoryMode || this.isHistoryFormComplete()),
      tap(() => {
        if (this.searchStockSupplier?.feature === STOCKS_FEATURES.INVENTAIRE) this.stocksSvc.announceInventaireLoading(true);
      }),
      switchMap(values => this.searchStockSupplier?.feature === STOCKS_FEATURES.INVENTAIRE ? this.produitDeclinaisonSvc.searchInventaires(this.searchStockSupplier, this.idsSitesSelected, this.idsZonesStockagesSelected, this.idsUdpZonesStockagesSelected, this.isHistoryMode ? this.inventaireDate : undefined) : this.produitDeclinaisonSvc.searchInStock(this.searchStockSupplier, this.idsSitesSelected, this.idsZonesStockagesSelected, this.idsUdpZonesStockagesSelected)),
      map(response => this.produitDeclinaisonSvc.announceResultSearchStocks(response, this.searchStockSupplier)),
      catchError(err => this.utils.handleError(err)))
      .subscribe();
  };

  changeZoneStockage = ($event: any): void => {
    const keys = this.treeViewZonesStockages.instance.getSelectedNodeKeys().filter(key => key.includes("-zds"));
    this.idsUdpZonesStockagesSelected = keys.map(id => parseInt(id.split('-')[3]));
    this.idsZonesStockagesSelected = keys.map(id => parseInt(id.split('-')[2]));
    // déclencher la recherche avec un temps de latence debounceTiem du this.formSearch.valueChanges
    this.formSearch.updateValueAndValidity({onlySelf: false, emitEvent: true});
  };

  private updateUdpZds: () => void = () => {
    this.stocksSvc.prepareSearch(this.idsSitesSelected)
      .subscribe(res => {
        const udpsZdps = res.resultList;
        if (udpsZdps && udpsZdps.length) {
          udpsZdps.forEach(udp => {
            udp.zonesStockage.forEach(zds => zds["icon"] = "fas fa-home");
            udp.id = `udp-${udp.id}`;
            udp["icon"] = "fa-industry fas";
            udp["items"] = udp.zonesStockage.map(zds => ({...zds, id: `${udp.id}-${zds.id}-${zds.idUdpZds}-zds`}));
            udp["expanded"] = true;
          });
          this.zonesStockages = Object.assign([], udpsZdps);
        }
      });
    this.formSearch.updateValueAndValidity({onlySelf: false, emitEvent: true});
  };

  loadSitesDisponiblesInventaire = (): void => {
    this.stocksSvc.getSitesDisponiblesInventaire()
      .subscribe(res => {
        this.sitesDisponiblesInventaire = res.resultList;
        const idsDispo = new Set(res.resultList.filter(d => !d.isSaved).map(d => d.siteId));
        this.historySites = this.sites.filter(s => idsDispo.has(s.id));
      });
  };

  onHistorySiteSelected($event: any) {
    if ($event) {
      this.isHistoryMode = true;
      this.historySiteSelected = $event;
      this.idsSitesSelected = [$event];
      this.produitDeclinaisonSvc.clearInventaireResults();
      this.stocksSvc.announceWaitingForHistoryParams(true);
      this.updateUdpZds();
      this.formSearch.controls['thresholdStocks'].setValue('3');
      const dispo = this.sitesDisponiblesInventaire.filter(d => d.siteId === $event && !d.isSaved)
        .map(date => new Date(date.annee, date.mois - 1));
      this.availableHistoriqueDates = dispo;
      this.onHistoDateSelected(dispo[0]);
    } else {
      this.isHistoryMode = false;
      this.historySiteSelected = undefined;
      this.availableHistoriqueDates = [];
      this.histoDate = undefined;
      this.inventaireDate = undefined;
      this.stocksSvc.announceInventaireDate(null);
      this.inventaireDatesDisponibles = [];
      this.formSearch.controls['thresholdStocks'].setValue('1')
      this.stocksSvc.announceWaitingForHistoryParams(false);
      this.initSites();
    }
  }

  onInventaireDateSelected = (date: Date): void => {
    this.inventaireDate = date;
    this.stocksSvc.announceInventaireDate(date);
    this.stocksSvc.announceWaitingForHistoryParams(false);
    this.formSearch.updateValueAndValidity({onlySelf: false, emitEvent: true});
  }

  onHistoDateSelected = (date: Date): void => {
    this.produitDeclinaisonSvc.clearInventaireResults();
    this.stocksSvc.announceWaitingForHistoryParams(true);
    if (date) {
      // Forcer au dernier jour du mois sélectionné
      this.histoDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.inventaireDate = undefined;
      this.stocksSvc.announceInventaireDate(null);
      this.inventaireDatesDisponibles = this.buildPeriodDates(this.histoDate, new Date());
      this.checkConflitsHistoriqueInventaire();
    } else {
      this.histoDate = undefined;
      this.inventaireDate = undefined;
      this.stocksSvc.announceInventaireDate(null);
      this.inventaireDatesDisponibles = [];
    }
  }

  private checkConflitsHistoriqueInventaire(): void {
    if (!this.historySiteSelected) return;
    this.isCheckingConflits = true;
    this.toogleLoading(true);
    this.stocksSvc.getConflitsHistoriqueInventaire(
      this.historySiteSelected as unknown as number,
      this.histoDate
    ).subscribe({
      next: (res) => {
        this.isCheckingConflits = false;
        this.toogleLoading(false);
        if (res.resultList && res.resultList.length > 0) {
          this.conflitList.set(res.resultList);
          this.displayConflitInventairePopup.set(true);
        }
      },
      error: (err) => {
        this.isCheckingConflits = false;
        this.toogleLoading(false);
        this.utils.handleError(err);
      }
    });
  }

  async saveHistoriqueInventaire() {
    const result = confirm("Vous êtes sur le point de valider votre inventaire, souhaitez continuez ?", "Validation inventaire");
    const isConfirmed: boolean = await result;
    if (!isConfirmed)
      return;

    this.isSavingHistorique = true;
    this.toogleLoading(this.isSavingHistorique);
    this.stocksSvc.saveHistoriqueInventaire(
      this.historySiteSelected as unknown as number,
      this.histoDate,
      this.typeAlimentaireSelected
    ).subscribe({
      next: () => {
        this.isSavingHistorique = false;
        this.toogleLoading(this.isSavingHistorique);
        this.loadSitesDisponiblesInventaire();
        this.typeAlimentaireSelected = null;
        this.onHistorySiteSelected(null);
      },
      error: (err) => {
        this.isSavingHistorique = false;
        this.toogleLoading(this.isSavingHistorique);
        this.utils.handleError(err);
      }
    });
  }

  private isHistoryFormComplete = (): boolean =>
    !!this.historySiteSelected && !!this.histoDate && !!this.inventaireDate && !this.isSavingHistorique;

  private buildPeriodDates = (start: Date, end: Date): Date[] => {
    const dates: Date[] = [];
    const current = new Date(start);
    current.setHours(0, 0, 0, 0);
    const endDay = new Date(end);
    endDay.setHours(0, 0, 0, 0);
    while (current <= endDay) {
      dates.push(new Date(current));
      current.setDate(current.getDate() + 1);
    }
    return dates;
  }
}
